import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=6437fc53&scoped=true"
var script = {}
import style0 from "./ModalHeader.vue?vue&type=style&index=0&id=6437fc53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6437fc53",
  null
  
)

export default component.exports